import script from "./QuickAction.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAction.vue?vue&type=script&setup=true&lang=js"

import "./QuickAction.vue?vue&type=style&index=0&id=1dcd43c5&lang=css"

const __exports__ = script;

export default __exports__